import { createContext, useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Where a tab panel's actions go when its container draws one shared toolbar
 * row: undefined without a container (render inline), null until that row has
 * mounted.
 */
const PanelToolbarContext = createContext<HTMLElement | null | undefined>(undefined);

export const PanelToolbarProvider = PanelToolbarContext.Provider;

interface PanelToolbarProps {
  children: ReactNode;
  /** Shown in place when there is no shared toolbar (defaults to the children). */
  inline?: ReactNode;
}

/** A panel's actions: in the container's toolbar row if there is one, else in place. */
export function PanelToolbar({ children, inline }: PanelToolbarProps) {
  const slot = useContext(PanelToolbarContext);
  if (slot === undefined) return <>{inline ?? children}</>;
  return slot ? createPortal(children, slot) : null;
}
